import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { hasPermission } from "@saleor/auth/misc";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import useUser from "@saleor/hooks/useUser";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import { PermissionEnum } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import { Payout_payouts_edges_node } from "../../types/Payout";
import { PayoutsUrlQueryParams } from "../../urls";
import PayoutsList from "../PayoutsList";
import {
  createFilterStructure,
  PayoutsFilterKeys,
  PayoutsListFilterOpts
} from "./filters";

interface PayoutsListPageProp
  extends ListProps,
    FilterPageProps<PayoutsFilterKeys, PayoutsListFilterOpts>,
    TabPageProps {
  params: PayoutsUrlQueryParams;
  payouts: Payout_payouts_edges_node[];
  hideAction: boolean;
  onBack: () => void;
  onSchedule: () => void;
}

const PayoutsListPage: React.FC<PayoutsListPageProp> = ({
  currentTab,
  hideAction,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  params,
  tabs,
  currencySymbol,
  onBack,
  onSchedule,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  const { user } = useUser();
  const isSpecialist = !hasPermission(
    PermissionEnum.MANAGE_PAYOUT_OPEN_ORDER,
    user
  );
  return (
    <>
      <Container maxWidth="xl">
        <PageHeader title="Payout">
          <Button
            color="primary"
            variant="contained"
            onClick={() => onSchedule()}
            disabled={isSpecialist}
          >
            Payment Schedule
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Payout"
            })}
            hideAction={hideAction}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <PayoutsList {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default PayoutsListPage;
